module.exports = __webpack_public_path__ + "static/media/fishing-spot.e90ef707.glb";